import React, {
    useState
} from 'react';

import {
    Tooltip
} from 'recharts';

// We're not fully using the recharts tooltip system here; in that system, the current active payload is passed as a
// prop to the tooltip. However, we need the ability to show a tooltip even when the chart is not being hovered, so
// we're just going to statically place it (e.g., the user is hovering over the tooltip, which is extending beyond
// the bounds of the chart).
export function useHoverableTooltip() {
    const [activelyHoveredTooltipIndex, setActivelyHoveredTooltipIndex] = useState(-1);
    const [focusedTooltipIndex, setFocusedTooltipIndex] = useState(-1);

    let activeTooltipIndex = -1;
    if (focusedTooltipIndex >= 0) {
        activeTooltipIndex = focusedTooltipIndex;
    } else if (activelyHoveredTooltipIndex >= 0) {
        activeTooltipIndex = activelyHoveredTooltipIndex;
    }

    const onPointActivated = (pointIdx, isTooltipActive) => {
        setActivelyHoveredTooltipIndex(isTooltipActive ? pointIdx : -1);
    };

    const onTooltipFocusChange = (isFocused) => {
        setFocusedTooltipIndex(currentlyFocusedIndex => {
            if (isFocused) {
                return activeTooltipIndex;
            } else {
                return -1;
            }
        });
    };

    return {
        activeTooltipIndex,
        onPointActivated,
        onTooltipFocusChange
    };
}

export function ChartTooltip({tooltipPayload, tooltipPoint, tooltipContent}) {
    if (!tooltipPoint || !tooltipContent) {
        return;
    }

    const {x, y} = tooltipPoint;

    if (x === null || y === null) {
        return;
    }

    return (
        <Tooltip
            offset={0}
            allowEscapeViewBox={{
                x: true,
                y: true
            }}
            isAnimationActive={false}
            payload={tooltipPayload}
            position={tooltipPoint}
            content={tooltipContent}
            wrapperStyle={{
                // an ongoing bug for Recharts is looking to make the "wrapperStyle" of this unnecessary https://github.com/recharts/recharts/issues/2920
                outline: 'none',

                // hack from https://github.com/recharts/recharts/issues/855
                visibility: 'visible'
            }}
        />
    );
}

// This static displayName is necessary for recharts to know how to render this component.
ChartTooltip.displayName = 'Tooltip';
